define(['es6-promise.auto', 'shared/set-up', 'app/main'], function() {
  if (!document.addEventListener) {
    require(['app/legacy-ie'], function (ie) {
      ie();
    });
  }
});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/app.js